/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_Converter_DescriptionInputs */



/**
* | output |
* | --- |
* | "Converter By CC Converter" |
*
* @param {Project_Converter_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const project_converter_description = /** @type {((inputs?: Project_Converter_DescriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Converter_DescriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Converti par CC Converter")
	if (locale === "de") return /** @type {LocalizedString} */ ("Konverter von CC Converter")
	if (locale === "it") return /** @type {LocalizedString} */ ("Convertitore di CC Converter")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Конвертер от CC Converter")
	if (locale === "es") return /** @type {LocalizedString} */ ("Convertidor de CC Converter")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("CC转换器")
	if (locale === "ja") return /** @type {LocalizedString} */ ("CCコンバーターによるコンバーター")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सीसी कन्वर्टर द्वारा कन्वर्टर")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Conversor por CC Converter")
	return /** @type {LocalizedString} */ ("Converter By CC Converter")
});